// extracted by mini-css-extract-plugin
export var productImage = "_m9-1";
export var viewLink = "_m9-2";
export var wishlistItem = "_m9-0";